import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Header } from './components/Header'
import { Dashboard } from './components/Dashboard'
import { AppView } from './components/AppView'
import { AdminPanel } from './components/AdminPanel'
import { ResetPasswordForm } from './components/ResetPasswordForm'
import { ProfilePage } from './components/ProfilePage'
import { ToastProvider } from './hooks/useToast'

function App() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--solharbor-gray-50)' }}>
      <ToastProvider>
      <Router>
        <Routes>
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/app/:appId/*" element={
            <ProtectedRoute>
              <AppView />
            </ProtectedRoute>
          } />
          <Route path="/*" element={
            <ProtectedRoute>
              <Header />
              <main className="h-screen">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/admin" element={<AdminPanel />} />
                  <Route path="/profile" element={<ProfilePage />} />
                </Routes>
              </main>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
      </ToastProvider>
    </div>
  )
}

export default App
